export default __webpack_public_path__ + "static/media/avital_stahl.f706ff09.jpeg";